// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label-main[data-v-790a87d1]{font-weight:700}.svg[data-v-790a87d1]{transition:fill .2s ease}.theme-dark[data-v-790a87d1]{color:#fff}.theme-dark .svg[data-v-790a87d1]{fill:#fff}.theme-light[data-v-790a87d1]{color:#3c3c3b}.theme-light .svg[data-v-790a87d1]{fill:#3c3c3b}.theme-dark:hover svg[data-v-790a87d1],.theme-light:hover svg[data-v-790a87d1]{fill:#c4a282}", ""]);
// Exports
module.exports = exports;
